import interceptor from '@/plugins/interceptor';
const pathController = '/tracking'

export default {
  state: () => ({
    
  }),
  mutations: { 
  },
  actions: {
    async tracking_orders(_,trackNumber) {
      return await interceptor.authenticate.get(`${process.env.VUE_APP_API_JUST_URL}${pathController}/${trackNumber}`);
    },
  }
}